export default {
  title: 'Transport Terms Management',

  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Term code, name',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  actions: {
    addTransportTerm: 'Add Transport Term',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  table: {
    termCode: 'Term Code',
    termNameCn: 'Term Name (Chinese)',
    termNameEn: 'Term Name (English)',
    description: 'Description',
    status: 'Status',
    operation: 'Operation'
  },

  form: {
    addTitle: 'Add Transport Term',
    editTitle: 'Edit Transport Term',
    termCode: 'Term Code',
    termNameCn: 'Term Name (Chinese)',
    termNameEn: 'Term Name (English)',
    description: 'Description',
    status: 'Status'
  },

  confirm: {
    enableItem: 'Are you sure to enable this transport term?',
    disableItem: 'Are you sure to disable this transport term?'
  },

  messages: {
    selectToAdd: 'Please select transport terms to add',
    associateSuccess: 'Successfully associated {count} transport terms',
    statusToggleSuccess: 'Transport term status updated successfully'
  },

  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  modal: {
    title: 'Select Transport Terms from Library',
    confirmText: 'Confirm Selection ({count})',
    statusPlaceholder: 'Please select status'
  }
}